import React from 'react';
import PropTypes from 'prop-types';
import { HeaderWrapper } from './MiniScoreboardRoundHeader.style';
import SeriesStatusMessageLayer from 'bdata-react-mini-scoreboard-game-infinity/lib/components/SeriesStatusMessageLayer/SeriesStatusMessageLayer';

const MiniScoreboardRoundHeader = ({
    seriesStatus = {},
    dictionary = {},
    broadcasts = {},
    isLoading,
    assetsBaseUrl,
    hideGameNumber,
    gameState,
    gameType,
    leagueID = null,
    ifNecessary
}) => {
    return (
        <HeaderWrapper>
            <SeriesStatusMessageLayer
                seriesStatus={ seriesStatus }
                dictionary={ dictionary }
                hideGameNumber={ hideGameNumber }
                broadcasts={ broadcasts }
                isLoading={ isLoading }
                assetsBaseUrl={ assetsBaseUrl }
                gameState={ gameState }
                gameType= { gameType }
                leagueID= { leagueID }
                ifNecessary= { ifNecessary }
            />
        </HeaderWrapper>
    );
};

MiniScoreboardRoundHeader.propTypes = {
    dictionary: PropTypes.object,
    seriesStatus: PropTypes.object,
    hideGameNumber: PropTypes.bool,
    broadcasts: PropTypes.object,
    isLoading: PropTypes.bool,
    assetsBaseUrl: PropTypes.string,
    gameState: PropTypes.string,
    ifNecessary: PropTypes.string,
    gameType: PropTypes.string,
    leagueID: PropTypes.number
};

export default MiniScoreboardRoundHeader;
